
import React, { Component } from 'react';
import Config from '../Config';
import Validate from '../components/Validate'

class EditCustomer extends Component {
    constructor(props) {
        super(props);

        // check if customer was previously edited
        var bp = this.props.changes.state.changedCustomer ?? this.props.bp;
        console.log("editing", bp);

        this.state = {
            salutation: bp.salutation,
            initials: bp.initials,
            prefix: bp.prefix,
            name: bp.name,
            zipCode: bp.shippingAddress.zipCode,
            streetNumber: bp.shippingAddress.streetNumber,
            building: bp.shippingAddress.building,
            phone1: bp.contact.phone1,
            phone2: bp.contact.phone2,
            mobile: bp.contact.mobile,
            email: bp.contact.email
        };
        this.bp = bp;

    }

    componentDidMount() {
        this.getAddress(this.bp.shippingAddress.zipCode);
    }

    close() {
        this.props.close();
    }

    save() {
        this.props.changes.SetCustomer({
            salutation: this.state.salutation,
            initials: this.state.initials ?? "",
            prefix: this.state.prefix ?? "",
            name: this.state.name,
            shippingAddress: {
                zipCode: this.state.zipCode ?? "",
                streetNumber: this.state.streetNumber,
                street: this.state.street ?? this.props.bp.shippingAddress.street,
                city: this.state.city ?? this.props.bp.shippingAddress.city,
                building: this.state.building ?? ""
            },
            contact: {
                mobile: this.state.mobile ?? "",
                phone1: this.state.phone1 ?? "",
                phone2: this.state.phone2 ?? "",
                email: this.state.email
            }
        });
        this.props.close();
    }
    changeZipCode(evt) {
        this.setState({ zipCode: evt.target.value });
        if (!evt.target.value || evt.target.value.length < 6 || evt.target.value.length > 7) return;
        this.getAddress(evt.target.value);
    }

    getAddress(code) {
        var url = Config.DigibonServiceBase + `zipCode/${code}`;
        var options = Config.GetBearer();

        fetch(url, options)
            .then((res) => { return res.ok ? res.json() : { status: res.status } })
            .then((json) => {
                if (json) this.setState({ street: json.street, city: json.city });
            });
    }

    setPhone(type, value) {
        const re = /^[0-9\b]+$/;

        // allow only empty or digits
        if (value === '' || re.test(value)) {
            this.setState({ [type]: value })
        }
    }

    render() {
        return <div>
            <h3>Wijzig klant gegevens</h3>

            <div className="row">
                <div className="col">
                    Aanhef<br />
                    <select className="form-control" onChange={p => this.setState({ salutation: p.target.value })} value={this.state.salutation}>
                        <option value="Dhr">Dhr</option>
                        <option value="Mevr">Mevr</option>
                    </select>
                </div>
                <div className="col">Voorletters<br />
                    <input className="form-control" value={this.state.initials} onChange={p => this.setState({ initials: p.target.value })} ></input>
                </div>
                <div className="col">Tussenvoegsel
                    <br />
                    <input className="form-control" value={this.state.prefix} onChange={p => this.setState({ prefix: p.target.value })} ></input></div>
                <div className="col-6">Naam
                    <br />
                    <input className="form-control" value={this.state.name} onChange={p => this.setState({ name: p.target.value })} ></input></div>

            </div>

            <div className="row mt-4">
                <div className="col">
                    <div className="row">
                        <div className="col">Postcode<br />
                            <input className="form-control" value={this.state.zipCode} maxLength="7" onChange={this.changeZipCode.bind(this)} ></input></div>
                        <div className="col">Huisnummer<br />
                            <input className="form-control" value={this.state.streetNumber} maxLength="10" onChange={p => this.setState({ streetNumber: p.target.value })} ></input></div>
                        <div className="col">Toevoeging<br />
                            <input className="form-control" value={this.state.building} onChange={p => this.setState({ building: p.target.value })} ></input></div>
                    </div>

                    {this.state.street && <div className="mt-2 mb-2">
                        <div><b>Adres:</b></div>
                        <div>{this.state.street} {this.state.streetNumber} {this.state.building}</div>
                        <div>{this.state.zipCode} {this.state.city}</div>
                    </div>}

                </div>
                <div className="col">
                    <div >Vast telefoon nummer 1<br />
                        <input className="form-control" value={this.state.phone1} maxLength="10" onChange={p => this.setPhone("phone1", p.target.value)} ></input>
                        <Validate value={this.state.phone1} type="phone"></Validate>
                    </div>
                    <div >Vast telefoon nummer 2<br />
                        <input className="form-control" value={this.state.phone2} maxLength="10" onChange={p => this.setPhone("phone2", p.target.value)} ></input>
                        <Validate value={this.state.phone2} type="phone"></Validate>
                    </div>
                    <div >Mobiel telefoon nummer<br />
                        <input className="form-control" value={this.state.mobile} maxLength="10" onChange={p => this.setPhone("mobile", p.target.value)} ></input>
                        <Validate value={this.state.mobile} type="phone"></Validate>
                    </div>
                    <div>
                        Email adres<br />
                        <input className="form-control" value={this.state.email} onChange={p => this.setState({ email: p.target.value })} ></input>
                        {this.bp.contact.email !== '' && this.state.email === "" &&
                            <div className="text-danger">
                                Email adres mag niet worden leeggehaald.
                            </div>
                        }
                        {
                            this.state.email !== "" &&
                            <Validate value={this.state.email} type="email"></Validate>
                        }
                    </div>
                </div>
            </div>

            <button className="btn btn-danger mt-4" onClick={this.close.bind(this)}>
                Annuleren
            </button>
            <button className="btn btn-primary ms-2 mt-4" onClick={this.save.bind(this)}>
                Opslaan
            </button>
        </div>
    }
}

export default EditCustomer;